import {
	DataDefinition,
	convertFrom,
	convertTime,
	convertTo,
	formatUnitData,
	generateDataLabel as generateLabel,
	getSecondsFromString,
	getUnitSpecifier,
	secondsToPrettyString,
	unitPosibilities,
} from "@soft-db/data-formatter";

export const useDataFormatter = createSharedComposable(() => {
	const { locale } = useI18n();

	function generateDataLabel(definition: DataDefinition) {
		const lang = locale.value.includes("fr") ? "fr-CA" : "en";

		return generateLabel(definition, lang);
	}

	// TODO: Add this in data-formatter lib ??
	function bytesToPrettyString(bytes: number, suffix = "B"): string {
		const units = ["", "Ki", "Mi", "Gi"];
		for (const unit of units) {
			if (Math.abs(bytes) < 1024) {
				return `${bytes.toFixed(1)} ${unit}${suffix}`;
			}

			bytes /= 1024;
		}

		return `${bytes.toFixed(1)} Ti${suffix}`;
	}

	return {
		convertFrom,
		convertTime,
		convertTo,
		formatUnitData,
		generateDataLabel,
		getSecondsFromString,
		getUnitSpecifier,
		secondsToPrettyString,
		unitPosibilities,
		bytesToPrettyString,
	};
});
